import data from './posts.json';
import resourceNotes from './resourceNotes.json';
// A language index is a navigation fallback, not a translated equivalent.
const pairs: Record<string, string> = {
 '/apps/': '/th/apps/', '/hub/': '/th/hub/', '/hub/login/': '/th/hub/login/',
 ...Object.fromEntries([...data, ...resourceNotes].map(post => [`/blog/${post.slug}/`, `/th/blog/${post.slug}/`])),
 '/resources/': '/th/resources/',
 '/': '/th/', '/blog/': '/th/blog/',
 '/ai-automation-thailand/': '/th/ai-automation-thailand/',
 '/services/workflow-automation/': '/th/services/workflow-automation/',
 '/services/ai-automation/': '/th/services/ai-automation/',
 '/services/business-process-automation/': '/th/services/business-process-automation/',
 '/services/custom-software/': '/th/services/custom-software/',
 '/services/ai-agents/': '/th/services/ai-agents/',
};
export const normalizedPath = (path: string) => `${path.replace(/\/+$/, '')}/`;
export const isThaiPath = (path: string) => path === '/th' || path.startsWith('/th/');
export function translationPath(path: string): string | undefined {
 const clean = normalizedPath(path);
 return isThaiPath(clean) ? Object.keys(pairs).find(key => pairs[key] === clean) : pairs[clean];
}
export const thaiPath = (path: string) => isThaiPath(path) ? normalizedPath(path) : translationPath(path) || (path.startsWith('/blog/') ? '/th/blog/' : '/th/');
export const englishPath = (path: string) => !isThaiPath(path) ? normalizedPath(path) : translationPath(path) || (path.startsWith('/th/blog/') ? '/blog/' : '/');
export const alternatePath = (path: string) => isThaiPath(path) ? englishPath(path) : thaiPath(path);
